import React from "react";
import { AlertTriangle } from "lucide-react";

// Phase 3M — extracted verbatim from RetailCustomer.jsx. Behaviour identical.
export default function ConfirmNewOrderModal({ onCancel, onConfirm }) {
  return (
    <div className="fixed inset-0 z-50 grid place-items-center px-4 bg-black/60" data-testid="retail-confirm-new-order">
      <div className="bg-white rounded-2xl p-6 max-w-sm w-full text-stone-900 shadow-2xl">
        <div className="flex items-center gap-2 mb-2">
          <AlertTriangle className="w-5 h-5 text-amber-500" />
          <h3 className="font-semibold text-lg">Start a new order?</h3>
        </div>
        <p className="text-sm text-stone-600">Starting a new sales order will clear your current cart. Continue?</p>
        <div className="mt-5 grid grid-cols-2 gap-3">
          <button
            type="button"
            onClick={onCancel}
            data-testid="retail-confirm-new-order-cancel"
            className="h-11 rounded-md border border-stone-300 text-sm font-medium text-stone-700 hover:bg-stone-50"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            data-testid="retail-confirm-new-order-confirm"
            className="h-11 rounded-md bg-orange-500 text-white text-sm font-semibold hover:bg-orange-600"
          >
            Start New Order
          </button>
        </div>
      </div>
    </div>
  );
}
